import { useMutation, UseMutationResult, useQueryClient } from "react-query";
import axios, { AxiosError } from "axios";
import CreateSegmentRequest from "../request/CreateSegmentRequest";
import Segment from "../model/Segment";

export const CreateSegmentApiService = async (
  request: CreateSegmentRequest
): Promise<Segment> => {
  const url = "/segments/";
  const { data } = await axios.post(url, request);
  return data;
};

const useCreateSegmentApiService = (): UseMutationResult<
  Segment,
  AxiosError,
  CreateSegmentRequest
> => {
  const queryClient = useQueryClient();
  return useMutation<Segment, AxiosError, CreateSegmentRequest>(
    CreateSegmentApiService,
    {
      mutationKey: "CreateSegmentApiService",
      onSuccess: () => {
        queryClient.invalidateQueries(["SegmentListApiService"]);
      },
    }
  );
};

export default useCreateSegmentApiService;
